
import { Finder } from "../finder/IFinder";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Bus from "@/lib/Bus";
const bus: Bus = new Bus().getBus();
import { Etap } from "./Etap";
import { Technologia } from "./Technologia";
import TechnologiaVue from "./Technologia.vue";
import  ButtonVue from "@/lib/Button.vue";
import Store from "@/store/Store"; 
import { MasterData } from "@/store/MasterData"; 


@Component({ name: "etap", components: { TechnologiaVue, ButtonVue } })
export default class WykrojnikiGenVue extends Vue {
  @Prop(Array) test_ptt!: any[];
  @Prop(Object) etap!: Etap;
  @Prop(String) title!: string;
  @Prop(Array) colors!: any[];
  //@Prop(Array) komponent_defs: any[] = [];
  key: number = 0;
  dbg_key:number=0;
  masterData: MasterData|undefined;
  technologieButtons:[]=[]
  rodzaje_farby:string[]=[]
  rodzaje_lakieru:string[]=[]
  kolory_studio_list:string[]=[]

  async mounted() {
    this.masterData = (await new Store().getStore()).masterData;

    if (this.masterData) {

    this.technologieButtons=this.masterData.typy_etapu_technologie[this.etap.etap_typ].technologie
      this.key++;
    }


    this.rodzaje_farby=Etap.etap_rodzaje_farby
    this.rodzaje_lakieru=Etap.etap_rodzaje_lakieru
    this.kolory_studio_list=Etap.etap_kolory_studio

  }

  async del_technologia(t: Technologia) {
    let id = t.id;

    for (let i = 0; i < this.etap.technologie.length; i++) {
      if (this.etap.technologie[i].id == id) {
        this.etap.technologie.splice(i, 1);
      }
    }
    this.technologia_changed();
  }

  async add_technologia(technologia_typ: string) {
    // typ=technologiaButton

    let newfoil_koszt_matrycypatrycy = 800;
    if (technologia_typ.indexOf("microembossing") > -1) {
      newfoil_koszt_matrycypatrycy = 0;
    }

    const technologia: Technologia = new Technologia()
    technologia.etap_id= this.etap.etap_id
    technologia.kalk_id=this.etap.kalk_id
    technologia.etap_typ=this.etap.etap_typ
    technologia.typ=technologia_typ
    
    //let t=  await call("svc/vue/technologiaSave", {technologia: technologia});
    this.etap.technologie.push(technologia);
    //this.$emit('etap_changed});
    this.$emit("etap_changed", {});
    this.scrollDown()
}

  async del_etap(etap: Etap) {
    this.$emit("del_etap", etap);
  }

  async technologia_changed() {
    console.log("etap: technologia_changed")
    this.$emit("etap_changed",{})
    this.key++;
  }

  async grupa_maszyn_changed() {

    this.$emit("grupa_maszyn_changed",{})
    this.key++;
  }

  async rodzaj_farby_changed() {
    this.$emit("rodzaj_farby_changed",{})
   
    this.key++;
  }

   async rodzaj_lakieru_changed() {
    this.$emit("rodzaj_lakieru_changed",{})
    this.key++;
  }

  async kolory_studio_changed() {
    this.$emit("etap_changed",{})
    this.key++;
  }

  async add_kolor_studio(color:string) {
    if (!this.etap.kolory_studio) this.etap.kolory_studio=[]
    this.etap.kolory_studio.push(color)
    this.$emit("etap_changed",{})
    this.key++;
  }

  
  async del_kolor_studio(i:number) {
    if (!this.etap.kolory_studio) return
    this.etap.kolory_studio.splice(i,1)
    this.$emit("etap_changed",{})
    this.key++;
  }


  dbg(etap:any) {
    if (etap.dbg) etap.dbg=0;
    else etap.dbg=1;
    this.dbg_key++
  }

  scrollDown() {
    const el = this.$refs.scrollDown;

    if (el) {
      // Use el.scrollIntoView() to instantly scroll to the element
      //(<any>el).scrollIntoView({behavior: 'smooth'});
    }
  }

}
